import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LockIcon from '@mui/icons-material/Lock';
import { Theme } from "@mui/material";
import { Translate } from "../../shared/LanguageService";

type NoAccessPageLabels = {
	title: string;
	description: string;
	additionalDescription: string;
}

type NoAccessPageProps = {
	labels: NoAccessPageLabels;
}

function NoAccessPage({ labels }: NoAccessPageProps) {
	return (
		<Box
			component="section"
			sx={{
				display: 'flex',
				flexDirection: {
					xs: 'column',
					md: 'row'
				},
				height: {
					md: 'calc(100vh - 144px)' /* 144 px = 48px for top position of header + 96 px height of actual header */
				},
				gap: '3rem',
				alignItems: 'center',
				justifyContent: 'center',
				fontFamily: 'Gilroy'
			}}
		>
			<Box sx={(theme: Theme) => ({
				width: '140px',
				height: '140px',
				borderRadius: '70px',
				backgroundColor: theme.palette.secondary.dark,
				padding: 0,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			})}>
				<LockIcon sx={{
					fill: '#fff',
					width: '56px',
					height: '72px'
				}} />
			</Box>
			<Box sx={(theme: Theme) => ({
				color: theme.palette.primary.light,
				display: 'flex',
				flexDirection: 'column',
				gap: {
					xs: '16px',
					md: 'unset'
				}
			})}>
				<Typography component="h1" vairant="h1" sx={(theme: Theme) => ({
					fontWeight: 700,
					lineHeight: '1.3',
					color: theme.palette.secondary.dark,
					fontSize: '40px'
				})}>
					{labels.title}
				</Typography>
				<Typography variant="body1" sx={{
					fontSize: '24px'
				}}>
					{labels.description}
				</Typography>
				<Typography variant="body1" sx={{
					fontSize: '24px'
				}}>
					{labels.additionalDescription}
				</Typography>
			</Box>
		</Box>
	)
}

function NoAccessPageTranslationLayer() {
	let labels: NoAccessPageLabels = {
		title: Translate('no-access/title'),
		description: Translate('no-access/description'),
		additionalDescription: Translate('no-access/additional-description')
	};

	return <NoAccessPage labels={labels} />
}

export default NoAccessPageTranslationLayer;
